export const isValidHexColor = (color: string): boolean =>
  !!color.match(/^#[0-9a-f]{6}$/i);
